import {
  FilterButton,
  FilterButtonAction,
  FilterButtonActiveOptions,
  FilterButtonLabel,
  FilterButtonMenu,
  FilterButtonMenuHeader,
  FilterMenuItem,
} from '@/components/filters/filter-button';
import PayoutBatchStatusBadge from '@/components/payouts/PayoutBatchStatusBadge';
import { Box, Popover, Portal, Text, VStack } from '@chakra-ui/react';
import { PayoutBatchStatus } from '@fluenceur/types';
import React, { useEffect, useState } from 'react';

// Define available status options for Payout Batches
const payoutBatchStatusOptions: { label: string; value: PayoutBatchStatus }[] = [
  { label: 'Draft', value: PayoutBatchStatus.DRAFT },
  { label: 'Pending', value: PayoutBatchStatus.PENDING },
  { label: 'Processing', value: PayoutBatchStatus.PROCESSING },
  { label: 'Completed', value: PayoutBatchStatus.COMPLETED },
  { label: 'Partially Completed', value: PayoutBatchStatus.PARTIALLY_COMPLETED },
  { label: 'Failed', value: PayoutBatchStatus.FAILED },
];

interface PayoutBatchStatusFilterProps {
  value: PayoutBatchStatus | null;
  onChange: (status: PayoutBatchStatus | null) => void;
  initialValue?: PayoutBatchStatus | null;
  label?: string; // Optional label prop
}

export const PayoutBatchStatusFilter: React.FC<PayoutBatchStatusFilterProps> = ({
  value,
  onChange,
  initialValue = null,
  label = 'Status', // Default label
}) => {
  const [tempStatus, setTempStatus] = useState<PayoutBatchStatus | null>(initialValue);

  useEffect(() => {
    setTempStatus(value);
  }, [value]);

  const handleApply = () => {
    onChange(tempStatus);
  };

  const handleClear = () => {
    setTempStatus(null);
    onChange(null);
  };

  const isFilterActive = value !== null;

  return (
    <FilterButton isFilterActive={isFilterActive} onClearFilter={handleClear}>
      <FilterButtonAction>
        <FilterButtonLabel>{label}</FilterButtonLabel>
        {isFilterActive && (
          <FilterButtonActiveOptions>
            {value && <PayoutBatchStatusBadge status={value} size="xs" fontSize="10px" />}
          </FilterButtonActiveOptions>
        )}
      </FilterButtonAction>
      <Portal>
        <Popover.Positioner>
          <FilterButtonMenu onApply={handleApply} maxWidth="250px">
            <FilterButtonMenuHeader title={label} onClearAll={handleClear} />
            <Box p={3}>
              <VStack gap={0.5} align="stretch">
                {payoutBatchStatusOptions.map((option) => (
                  <FilterMenuItem
                    key={option.value}
                    onClick={() => setTempStatus(option.value)}
                    isSelected={tempStatus === option.value}
                  >
                    <Text fontSize="sm" fontWeight="normal">
                      {option.label}
                    </Text>
                  </FilterMenuItem>
                ))}
              </VStack>
            </Box>
          </FilterButtonMenu>
        </Popover.Positioner>
      </Portal>
    </FilterButton>
  );
};
